import * as React from 'react';
import { useState, useRef, useEffect } from 'react';
import { useNavigate, Link, useLocation, Outlet } from 'react-router-dom';
import {
  Box, Typography, IconButton, Drawer, AppBar, Toolbar,
  List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, MenuItem, Button,
  InputBase, Avatar, useMediaQuery, TextField,
  ClickAwayListener, Badge,
  Tooltip
} from '@mui/material';
import InputAdornment from "@mui/material/InputAdornment";
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import RealEstateAgentOutlinedIcon from '@mui/icons-material/RealEstateAgentOutlined';
import DnsIcon from '@mui/icons-material/Dns';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import BadgeIcon from '@mui/icons-material/Badge';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import TaskIcon from '@mui/icons-material/Task';
import PlaceIcon from '@mui/icons-material/Place';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import { AuthContext } from '..';

import Swal from 'sweetalert2';
import axios from 'axios';
import { useContext } from 'react';
import { Autocomplete } from '@mui/material';
import { fontWeight } from '@mui/system';


export default function ResponsiveSidebar() {

  const navigate = useNavigate();
  const location = useLocation();
  const [paperOpen, setPaperOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [data, setData] = useState({})
  const [pageTitle, setPageTitle] = useState('');
  const [openMasters, setOpenMasters] = useState(false);
  const { logout, permissions, companyid, employeeId, isCEO } = useContext(AuthContext);
  const [billsPermission, setBillsPermission] = useState(true);
  const [clientsPermission, setClientsPermission] = useState(true);
  const [employeesPermission, setEmployeesPermission] = useState(true);
  const [followupPermission, setFollowupPermission] = useState(true);
  const [leadsPermission, setLeadsPermission] = useState(true);
  const [mastersPermission, setMastersPermission] = useState(true);
  const [roleManagementPermission, setRoleManagementPermission] = useState(true);
  const [servicesPermission, setServicesPermission] = useState(true);
  const [orientationPermissions, setOrientationPermissions] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notificationOpen, setNotificationOpen] = useState(false);



  const permissionsdata = () => {
    setBillsPermission(permissions?.bills?.read === true);
    setMastersPermission(permissions?.masters?.read === true);
    setEmployeesPermission(permissions?.employees?.read === true);
    setClientsPermission(permissions?.clients?.read === true);
    setFollowupPermission(permissions?.followup?.read === true);
    setLeadsPermission(permissions?.leads?.read === true);
    setRoleManagementPermission(permissions?.rolemanagement?.read === true);
    setServicesPermission(permissions?.services?.read === true);
    setOrientationPermissions(permissions?.orientation?.read === true);
  };




  useEffect(() => {
    authenticateddata();
  }, [])
  useEffect(() => {
    permissionsdata()
  }, [permissions])

  useEffect(() => {
    if (!companyid) return;

    const fetchNotifications = async () => {
      const payload = {
        isCEO: isCEO,
        employeeId: employeeId
      }
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_LINKS}/notifications/today/${companyid}`,
          { params: payload, withCredentials: true }
        );

        if (res.data.success) {
          setNotifications(res.data.data);
          setNotificationCount(res.data.data.length);
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };

    fetchNotifications();

    // Optional: refresh notifications every 1 min
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, [companyid, isCEO]);

  const isLargeScreen = useMediaQuery('(min-width:1024px)');
  const isMediumScreen = useMediaQuery('(min-width:600px) and (max-width:1023px)');
  const isSmallScreen = useMediaQuery('(max-width:599px)');

  const adjustedDrawerWidth = 240;

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setPaperOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const authenticateddata = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/tokendata/tokendata`, { withCredentials: true }).then((res) => {
      setData(res.data)
    }).catch((err) => {
      alert('error has been occured')
    })
  }

  useEffect(() => {
    const handleKeyDown = () => {
      if (paperOpen) setPaperOpen(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [paperOpen]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = async () => {
    setPaperOpen(false);
    const success = await logout();
    if (success) {
      Swal.fire({
        icon: 'success',
        title: 'Logged out',
        text: 'You have been successfully logged out.',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate('/login'));
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Logout Failed',
        text: 'Something went wrong while logging out.',
      });
    }
  };
  const markasread = async (n) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_LINKS}/notifications/read/${n}`,
        {},
        { withCredentials: true }
      );
      setNotifications((prev) => prev.filter(item => item.id !== n));
      setNotificationCount((prev) => prev - 1);
    } catch (err) {
      console.error("Error marking notification as read:", err);
    }
  }


  const navItems = [
    { text: 'Dashboard', icon: <HomeOutlinedIcon />, path: '/' },
    ...(mastersPermission ? [{
      text: 'Masters',
      icon: <DnsIcon />,
      children: [
        { text: 'Leads', icon: <LeaderboardIcon />, path: '/masters/leads' },
        { text: 'Clients', icon: <AssignmentIndIcon />, path: '/masters/clients' },
        { text: 'Employees', icon: <BadgeIcon />, path: '/masters/employees' },
        { text: 'Location', icon: <PlaceIcon />, path: '/masters/locations' },
        { text: 'Others', icon: <TaskIcon />, path: '/masters/tasks&services' },


      ]
    }] : []),
    ...((leadsPermission || followupPermission) ? [{ text: 'Leads', icon: <AssessmentOutlinedIcon />, path: '/leads' }] : []),
    ...(orientationPermissions ? [{ text: 'Demo', icon: <WorkOutlineOutlinedIcon />, path: '/demo' }] : []),
    ...(clientsPermission ? [{ text: 'Clients', icon: <GroupOutlinedIcon />, path: '/clients' }] : []),
    ...(billsPermission ? [{ text: 'Sales & Billing', icon: <RealEstateAgentOutlinedIcon />, path: '/sales' }] : []),
    // ...(billspermisson?[{ text: 'Budget', icon: <AttachMoneyOutlinedIcon />, path: '/payables' }]:[]),
    ...(employeesPermission ? [{ text: 'Employees', icon: <PersonOutlinedIcon />, path: '/employees' }] : []),
    ...(servicesPermission ? [{ text: 'Products', icon: <HomeRepairServiceIcon />, path: '/services' }] : []),
    ...(roleManagementPermission ? [{ text: 'Role Management', icon: <BadgeOutlinedIcon />, path: '/duties' }] : [])
  ]
  const searchOptions = [
    ...navItems.map((item) => {
      if (item.children) {
        return item.children.map((child) => ({
          label: `Masters / ${child.text}`,
          path: child.path,
        }));
      }
      return { label: item.text, path: item.path };
    })
  ].flat();




  useEffect(() => {
    const titles = {
      '/': 'Dashboard',
      '/leads': 'Leads',
      '/clients': 'Clients',
      '/tasks': 'Tasks',
      '/sales': 'Sales',
      '/payables': 'Payables & Receivables',
      '/duties': 'Role Management',
      '/employees': 'Employees',
      '/services': 'Services',
      '/settings': 'Settings',
      '/masters/leads': 'Leads Masters',
      '/masters/clients': 'Clients Masters',
      '/masters/employees': 'Employees Masters',
      '/masters/locations': 'Location Masters',
      '/masters/tasks&services': 'Tasks & Serivices Masters',
    };
    if (location.pathname.startsWith('/masters')) {
      setOpenMasters(true);
    } else {
      setOpenMasters(false);
    }

    const title = titles[location.pathname] ?? 'CRM';
    setPageTitle(title);
    document.title = title + ' | CRM';
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;
  const isMastersActive = location.pathname.startsWith('/masters');



  const drawer = (
    <div>
      <Toolbar sx={{ justifyContent: 'center', mt: 1 }}>
        <img src="/suntech_logo.png" style={{ height: '100px', marginTop: '2px' }} alt="Hippo Logo" />
      </Toolbar>
      <List sx={{ mt: 2 }}>
        {navItems.map((item) => (
          item.text === 'Masters' ? (
            <Box key={item.text}>
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    px: 3,
                    height: '30px',
                    bgcolor: isMastersActive ? '#e0f2ff' : 'transparent'
                  }}
                  onClick={() => setOpenMasters(!openMasters)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={<Typography fontWeight={500} ml={-1} sx={{ fontFamily: 'Open Sans' }}>{item.text}</Typography>} />
                  {openMasters ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </ListItemButton>
              </ListItem>

              {openMasters && item.children.map((child) => (
                <ListItem key={child.text} disablePadding>
                  <ListItemButton
                    component={Link}
                    to={child.path}
                    selected={isActive(child.path)}
                    onClick={() => {
                      if (!isLargeScreen) handleDrawerToggle();
                    }}
                    sx={{
                      pl: 5,
                      height: '30px',
                      '&.Mui-selected': {
                        bgcolor: '#0b85c8',
                        color: 'white',
                        fontFamily: 'Open Sans',
                        '& .MuiListItemIcon-root': {
                          color: 'white',
                          fontFamily: 'Open Sans'
                        },
                        '&:hover': {
                          bgcolor: '#0b85c8',
                          color: 'black',
                          '& .MuiListItemIcon-root': {
                            color: 'black',
                            fontFamily: 'Open Sans'
                          }
                        }

                      },
                      fontFamily: 'Open Sans'

                    }}
                  >
                    <ListItemIcon sx={{ minWidth: '40px', mr: 1 }}>
                      {child.icon}
                    </ListItemIcon>
                    <ListItemText primary={child.text} sx={{ fontFamily: 'Open Sans' }} />
                  </ListItemButton>
                </ListItem>
              ))}
            </Box>
          ) : (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                component={Link}
                to={item.path}
                selected={isActive(item.path)}
                onClick={() => !isLargeScreen && handleDrawerToggle()}
                sx={{
                  py: 1.5,
                  px: 3,
                  height: '30px',
                  '&.Mui-selected': {
                    bgcolor: '#0b85c8',
                    color: 'white',
                    '& .MuiListItemIcon-root': {
                      color: 'white'
                    },
                    '&:hover': {
                      bgcolor: '#0b85c8',
                      color: 'black',
                      '& .MuiListItemIcon-root': {
                        color: 'black'
                      }
                    }
                  }

                }}
              >
                <ListItemIcon sx={{ minWidth: '40px', mr: 1 }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={<Typography sx={{ fontWeight: 500, fontFamily: 'Open Sans' }}>{item.text}</Typography>} />
              </ListItemButton>
            </ListItem>
          )
        ))}
      </List>

    </div>
  );







  return (
    <Box sx={{ display: 'flex', fontFamily: 'Open Sans' }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: '#fff',
          width: isLargeScreen ? `calc(100% - ${adjustedDrawerWidth}px)` : '100%',
          ml: isLargeScreen ? `${adjustedDrawerWidth}px` : 0,
          height: 64,
          justifyContent: 'center',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 2, sm: 3 }, bgcolor: '#f5f5fa' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {!isLargeScreen && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, color: 'black' }}
              >
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h6" noWrap sx={{
              fontWeight: 900,
              color: 'black',
              fontFamily: 'Open Sans',
              fontSize: { xs: '20px', sm: '25px' }
            }}>
              {pageTitle}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
            {(isMediumScreen || isLargeScreen) && (
              <Autocomplete
                size="small"
                options={searchOptions}
                getOptionLabel={(option) => option.label}
                onChange={(e, value) => {
                  if (value) navigate(value.path);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search..."
                    variant="outlined"
                    size="small"
                    sx={{
                      width: isLargeScreen ? 280 : 150,
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      boxShadow: 1,
                      "& .MuiOutlinedInput-root": {
                        height: 36,
                        fontSize: 14,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end" sx={{ ml: 10 }} >
                          <SearchIcon sx={{ color: "#999", fontSize: 20, mr: -3 }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            )}

            <ClickAwayListener onClickAway={() => setNotificationOpen(false)}>
              <Box sx={{ position: 'relative' }}>
                <IconButton
                  sx={{ border: '1px solid #ccc', borderRadius: '8px', width: 36, height: 36, p: 0 }}
                  onClick={() => setNotificationOpen(!notificationOpen)}
                >
                  <Badge badgeContent={notificationCount} color="error">
                    <NotificationsOutlinedIcon sx={{ fontSize: 20, color: '#333' }} />
                  </Badge>
                </IconButton>

                {notificationOpen && (
                  <Paper sx={{
                    position: 'absolute',
                    top: 50,
                    right: 0,
                    zIndex: 10,
                    width: 250,
                    maxHeight: 400,
                    overflowY: 'auto',
                    borderRadius: '8px',
                    boxShadow: 3
                  }}>
                    {notifications.length === 0 ? (
                      <Typography sx={{ p: 1, textAlign: 'center' }}>No notifications</Typography>
                    ) : notifications.map((n) => (
                      <Box
                        key={n.id}
                        sx={{
                          p: 1,
                          borderBottom: '1px solid #eee',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box>
                          {/* <Typography sx={{ fontWeight: 600, fontSize: 13 }}>{n.title}</Typography> */}
                          <Typography sx={{ fontSize: 13 }}>{n.message}</Typography>
                          <Typography sx={{ fontSize: 11, color: '#888' }}>
                            {new Date(n.created_at).toLocaleString()}
                          </Typography>
                          {isCEO && <Typography sx={{ fontSize: 13 }}><span style={{ fontWeight: 600 }}>Assigned To:</span>
                            {n?.assignedto
                              ? n.assignedto.charAt(0).toUpperCase() + n.assignedto.slice(1)
                              : ''}
                          </Typography>}

                        </Box>

                        <IconButton
                          size="small"
                          onClick={() => markasread(n.id)}
                        >
                          <Tooltip title="Mark As Read" arrow>
                            <CloseIcon fontSize="small" />
                          </Tooltip>
                        </IconButton>
                      </Box>

                    ))}
                  </Paper>
                )}
              </Box>
            </ClickAwayListener>




            {!isSmallScreen && (
              <Box sx={{
                textAlign: 'right',
                ml: { xs: 1, sm: 3 },
                mr: { xs: 1, sm: 3 },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <Typography sx={{
                  fontWeight: 600,
                  fontSize: { xs: '14px', sm: '16px' },
                  lineHeight: 1,
                  fontFamily: 'Open Sans',
                  color: '#888',
                  textAlign: 'center'
                }}>
                  {data.name}
                </Typography>
                <Typography sx={{
                  fontSize: { xs: '10px', sm: '12px' },
                  color: '#888',
                  fontFamily: 'Open Sans',
                  lineHeight: 1,
                  mt: 0.5,
                  textAlign: 'center'
                }}>
                  {data.role}
                </Typography>
              </Box>
            )}
            <ClickAwayListener onClickAway={() => { setPaperOpen(false) }}>
              <Box ref={dropdownRef} sx={{ position: 'relative', display: 'flex', gap: 1 }}>
                <IconButton
                  onClick={() => { paperOpen ? setPaperOpen(false) : setPaperOpen(true) }}
                  sx={{
                    padding: 1.5,
                    width: 36,
                    height: 36,
                  }}
                >
                  <Avatar variant='square' sx={{
                    width: 36,
                    height: 36,
                    boxShadow: '1px 1px 10px white',
                    borderRadius: '8px',
                    fontWeight: 600,
                    bgcolor: '#ccc',
                    color: 'white'
                  }}>
                    {data?.name?.charAt(0)?.toUpperCase() || ''}
                  </Avatar>
                </IconButton>

                {!isSmallScreen && (
                  <IconButton
                    onClick={() => { paperOpen ? setPaperOpen(false) : setPaperOpen(true) }}
                    sx={{
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      width: 36,
                      height: 36,
                    }}
                  >
                    {paperOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </IconButton>
                )}

                {paperOpen && (
                  <Paper sx={{
                    position: 'absolute',
                    top: 48,
                    right: 0,
                    zIndex: 10,
                    width: 200,
                    borderRadius: '8px',
                    boxShadow: 3,
                    py: 1,
                    fontFamily: 'Open Sans',
                    mt: 1,
                    textAlign: 'center'
                  }}>

                    {isCEO && <Button
                      component={Link}
                      to="/settings"
                      onClick={() => setPaperOpen(false)}
                      sx={{
                        fontFamily: 'Open Sans',
                        fontSize: '14px',
                        width: '100%',
                        textTransform: 'none',
                        justifyContent: 'center',
                        color: '#888',
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        '&:hover': {
                          backgroundColor: '#0b85c8',
                          color: 'white',
                        },
                      }}
                    >
                      <SettingsIcon fontSize="small" />
                      Settings
                    </Button>}
                    <Button
                      onClick={() => { setPaperOpen(false); handleLogout() }}
                      sx={{
                        fontFamily: 'Open Sans',
                        fontSize: '14px',
                        width: '100%',
                        textTransform: 'none',
                        justifyContent: 'center',
                        color: '#888',
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        '&:hover': {
                          backgroundColor: '#0b85c8',
                          color: 'white',
                        },
                      }}
                    >
                      <LogoutIcon fontSize="small" />
                      Logout
                    </Button>
                  </Paper>
                )}
              </Box>
            </ClickAwayListener>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: isLargeScreen ? adjustedDrawerWidth : 0,
          flexShrink: isLargeScreen ? 0 : undefined
        }}
        aria-label="sidebar"
      >

        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', lg: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: adjustedDrawerWidth,
              bgcolor: '#f0f9ff',
              boxShadow: '0px 0px 5px rgba(11, 134, 200, 0.56)'
            },
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: isLargeScreen ? 'block' : 'none',
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: adjustedDrawerWidth,
              bgcolor: '#f0f9ff',
              boxShadow: '0px 0px 5px rgba(11, 134, 200, 0.56)'
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // width: { 
          //   xs: '100%',      
          //   sm: '100%',      
          //   md: '100%',     
          //   lg: `calc(100% - ${adjustedDrawerWidth}px)` 
          // },
          width: isLargeScreen ? `calc(100% - ${adjustedDrawerWidth}px)` : '100%',

          mt: {
            xs: 7,
            sm: 8
          },
          bgcolor: '#f5f5fa',
          minHeight: '100vh',
          py: 2,
          px: {
            xs: 1.5,
            sm: 2,
            md: 3,
            lg: 3
          },
          overflowX: 'hidden',
          position: 'relative'
        }}
      >
        <Box
          sx={{
            maxWidth: '100%',
            margin: '0 auto',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}